import { abyssColors } from '@/theme/colors';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SwitchView = styled(Box)({
  display: 'flex',  
  justifyContent: 'space-between',
  padding: '0.4rem',
  borderRadius: '0.8rem',
  height: '3.4rem',
  background: `${abyssColors.primary[50]}`,
});
